import styles from './Alert.module.css';
import { classList } from '../../helpers/classList';

export type AlertTone = 'error' | 'success' | 'warning' | 'info';

export interface AlertProps {
  tone?: AlertTone;
  className?: string;
  /** Hide the leading icon where the surrounding layout already carries one. */
  hideIcon?: boolean;
  children?: React.ReactNode;
}

const Icon = ({ tone }: { tone: AlertTone }) => {
  const common = {
    width: 20,
    height: 20,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    className: styles.icon,
    'aria-hidden': true,
  };

  switch (tone) {
    case 'success':
      return (
        <svg {...common}>
          <circle cx='12' cy='12' r='9' />
          <path d='M8 12.5l2.5 2.5L16 9.5' />
        </svg>
      );
    case 'warning':
      return (
        <svg {...common}>
          <path d='M12 4l9 16H3Z' />
          <path d='M12 10v4M12 17.5v.5' />
        </svg>
      );
    case 'info':
      return (
        <svg {...common}>
          <circle cx='12' cy='12' r='9' />
          <path d='M12 11v5M12 7.5v.5' />
        </svg>
      );
    case 'error':
    default:
      return (
        <svg {...common}>
          <circle cx='12' cy='12' r='9' />
          <path d='M12 7v6M12 16.5v.5' />
        </svg>
      );
  }
};

export const Alert = ({ tone = 'error', className, hideIcon, children }: AlertProps) => (
  <div className={classList(styles.alert, styles[tone], className)} role={tone === 'error' ? 'alert' : 'status'}>
    {!hideIcon && <Icon tone={tone} />}
    <div className={styles.body}>{children}</div>
  </div>
);
